import * as Vuex from "vuex";
import { ArrayTagComments } from "@/entities/tag-config-comments";
import { httpByCurrentCustomer } from "@/lib/client";

const tagConfigModule: Vuex.Module<tagConfigCommentsStoreState, {}> = {
  state: {
    tagList: [],
  },
  getters: {
    listTagComments(state) {
      const array: Array<string> = [];
      for (let i = 0; i < state.tagList.length; i++) {
        for (let j = 0; j < state.tagList[i].Values.length; j++) {
          array.push(state.tagList[i].Tag + ":" + state.tagList[i].Values[j]);
        }
      }
      return array;
    },
  },
  mutations: {
    SET_TAG_COMMENTS(state, payload: ArrayTagComments[]) {
      state.tagList = payload;
    },
  },
  actions: {
    async getTagComments({ commit }) {
      const responsePresetTags = await httpByCurrentCustomer()
        .get("presetTags")
        .json<ArrayTagComments[]>();
      if (Array.isArray(responsePresetTags)) {
        commit("SET_TAG_COMMENTS", responsePresetTags);
      } else {
        commit("SET_TAG_COMMENTS", []);
      }
    },
    async updateTagComments({ commit }, data: ArrayTagComments[]) {
      await httpByCurrentCustomer()
        .put("presetTags", { json: data })
        .json<ArrayTagComments[]>();
    },
  },
  namespaced: true,
};

type tagConfigCommentsStoreState = {
  tagList: ArrayTagComments[];
};
export default tagConfigModule;
